import 'css-chunksrc/client/scenes/addPlanzoneResourceToProjects/projectsSelection/zones/zone/projects/styles.scss';export default {
  "projects": "_projects_1agdd_1"
};